import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import { Row, Col, Popconfirm, Button, Select } from 'antd';

import { IconDelete, IconRight } from '../../../../../../../data/assets/icons';

import ErrorBoundary from '../../../../../../../components/errorboundary';
import InputItem from '../../../../../../../components/form/inputitem';
import SelectItem from '../../../../../../../components/form/selectitem';
import SelectArrayItem from '../../../../../../../components/form/selectarrayitem';
import SwitchItem from '../../../../../../../components/form/switchitem';

const Option = Select.Option;
class EntityNodeForm extends Component {
    constructor() {
        super();
        this.state = {
            edge_index: -1
        };
    }

    componentDidMount() {
        const { preemptive_data, getPreemptiveData } = this.props;
        if (isEmpty(preemptive_data.actions) || isEmpty(preemptive_data.variables) || isEmpty(preemptive_data.messages)) {
            getPreemptiveData();
        }
    }

    render() {
        const { preemptive_data, node_details, possible_rules, workflows, onChangeName, onChangeAction, onChangeVariable, onChangeEventTag, onChangeEventTagType, onClickDeleteMessageBefore, onClickDeleteMessageAfter, onChangeStart, onChangeEnd, onChangeAuthRequired, show_edit_edges, onChangeTargetWorkflow, onChangeTargetNode, onChangeLabel, onChangeCustomRule, onChangeRule, onChangeResetParameterKey, onChangeResetParameterValue, deleteResetParameter, addResetParameter, addMessageBefore, addMessageAfter } = this.props;
        const { edge_index } = this.state;

        return (
            <div className="ori-tb-pad-10 ori-lr-pad-15 ori-full-parent-height ori-overflow-auto">
                <ErrorBoundary>
                    <InputItem title="name" placeholder="Enter Name" value={node_details.name} onChange={onChangeName} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SelectItem show_search allow_clear title="action" dropdown_class="ori-zindex-99999" placeholder="Select an action" options={preemptive_data.actions} value={node_details.action} onChange={onChangeAction} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SelectItem show_search allow_clear title="variable" dropdown_class="ori-zindex-99999" placeholder="Select a variable" value={node_details.variable} options={preemptive_data.variables} onChange={onChangeVariable} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SelectItem allow_clear show_search title="Event tag" placeholder="Select event tag" options={preemptive_data.event_tags} value={node_details.tag} onChange={onChangeEventTag} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SelectItem allow_clear show_search title="Event tag type" placeholder="Select event tag type" options={preemptive_data.event_types} value={node_details.tag_type} onChange={onChangeEventTagType} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SelectArrayItem type="object" title="message before" select_dropdown_class="ori-zindex-99999" select_placeholder="Select new message before" add_btn_text="add message before" popconfirm_placement="topRight" popconfirm_overlay_class="ori-zindex-99999" array={node_details.message_before} options={preemptive_data.messages} onClickAdd={addMessageBefore} onClickDelete={onClickDeleteMessageBefore} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SelectArrayItem type="object" title="message after" select_dropdown_class="ori-zindex-99999" select_placeholder="Add new message after" add_btn_text="add message after" popconfirm_placement="topRight" popconfirm_overlay_class="ori-zindex-99999" array={node_details.message_after} options={preemptive_data.messages} onClickAdd={addMessageAfter} onClickDelete={onClickDeleteMessageAfter} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SwitchItem title="Start Node" checked={node_details.start} onChange={onChangeStart} switch_first seperated />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SwitchItem title="End Node" checked={node_details.end} onChange={onChangeEnd} switch_first seperated />
                </ErrorBoundary>
                <ErrorBoundary>
                    <SwitchItem title="Auth Required" checked={node_details.auth_required} onChange={onChangeAuthRequired} switch_first seperated />
                </ErrorBoundary>
                {
                    show_edit_edges && node_details.outEdges && node_details.outEdges.length > 0 &&
                    <div className="ori-full-width ori-tb-pad-5">
                        <p className="ori-font-md ori-font-bold ori-t-pad-10">Edit out going edges</p>
                        {
                            node_details.outEdges.map((edge, index) => {
                                return (
                                    <ErrorBoundary key={index}>
                                        <div className="ori-tb-pad-5">
                                            <div className="ori-relative ori-lr-pad-10 ori-tb-pad-15 ori-border-default ori-bg-default ori-cursor-ptr" onClick={() => this.setState({ edge_index: edge_index === index ? -1 : index })}>
                                                <p className="ori-capitalize-first ori-text-overflow-dotted">{edge.label ? edge.label : 'Edge with no label'}</p>
                                                <div className={classNames("ori-absolute ori-pad-5 ori-align-right ori-font-light ", { "ori-rotate-neg-90 ori-transition-half": edge_index === index, "ori-transition-half": edge_index !== index })} style={{ top: '20%' }}>
                                                    <IconRight size={22} />
                                                </div>
                                            </div>
                                            {
                                                edge_index === index &&
                                                <div className="ori-animated ori-fade-in ori-lr-pad-10 ori-tb-pad-5 ori-l-border-default ori-r-border-default ori-b-border-default ori-bg-default">
                                                    <ErrorBoundary>
                                                        <div className="ori-tb-pad-7">
                                                            <p className="ori-b-mrgn-5 ori-capitalize-first">Target Workflow</p>
                                                            <Select showSearch className="ori-full-width" dropdownClassName="ori-zindex-99999" placeholder="Select Target Workflow" optionFilterProp="children" filterOption={(input, option) => option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} value={edge.target.wid} onChange={(value) => { onChangeTargetWorkflow(value, index); }} >
                                                                {
                                                                    workflows.map((workflow) => {
                                                                        return (
                                                                            <Option key={workflow.wid} value={workflow.wid}>{workflow.name}</Option>
                                                                        );
                                                                    })
                                                                }
                                                            </Select>
                                                        </div>
                                                    </ErrorBoundary>
                                                    {
                                                        edge && edge.target && edge.target.wid &&
                                                        <ErrorBoundary>
                                                            <div className="ori-relative ori-tb-pad-7">
                                                                <p className="ori-b-mrgn-5 ori-capitalize-first">Workflow Node</p>
                                                                <Select showSearch className="ori-full-width" dropdownClassName="ori-zindex-99999" placeholder="Select Workflow's Node" optionFilterProp="children" filterOption={(input, option) => option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} value={edge.target.nodeId} onChange={(value) => { onChangeTargetNode(value, index); }}>
                                                                    {
                                                                        workflows.find((workflow) => { return (workflow.wid === edge.target.wid); }).nodes.map((node) => {
                                                                            return (
                                                                                <Option key={node.nodeId} value={node.nodeId}>{node.name}</Option>
                                                                            );
                                                                        })
                                                                    }
                                                                </Select>
                                                            </div>
                                                        </ErrorBoundary>
                                                    }
                                                    <ErrorBoundary>
                                                        <InputItem title="Label" placeholder="Enter Edge Label" value={edge.label} onChange={(e) => { onChangeLabel(e.target.value, index); }} />
                                                    </ErrorBoundary>
                                                    <ErrorBoundary>
                                                        <SwitchItem title="Custom Rule" checked={edge.customRule} onChange={(value) => { onChangeCustomRule(value, index) }} switch_first seperated />
                                                    </ErrorBoundary>
                                                    {
                                                        !isEmpty(possible_rules) && !edge.customRule &&
                                                        <ErrorBoundary>
                                                            <SelectItem show_search title="Rule" dropdown_class="ori-zindex-99999" placeholder="Select rule for edge" options={possible_rules} value={edge.rule} onChange={(value) => { onChangeRule(value, index); }} />
                                                        </ErrorBoundary>
                                                    }
                                                    {
                                                        edge.customRule &&
                                                        <ErrorBoundary>
                                                            <InputItem title="Custom Rule" placeholder="Enter Custom Rule" value={edge.rule} onChange={(e) => { onChangeRule(e.target.value, index); }} />
                                                        </ErrorBoundary>
                                                    }
                                                    <div className="ori-t-pad-5">
                                                        <div className="ori-r-pad-30">
                                                            <p className="ori-t-mrgn-5">Reset Parameters</p>
                                                            {
                                                                edge.resetParameters.map((parameter, parameter_index) => {
                                                                    return (
                                                                        <ErrorBoundary key={parameter_index}>
                                                                            <Row gutter={8} className="ori-relative">
                                                                                <Col xs={24} sm={12}>
                                                                                    <SelectItem show_search dropdown_class="ori-zindex-99999" placeholder="Select variable" options={preemptive_data.variables} value={parameter.key} onChange={(value) => onChangeResetParameterKey(value, index, parameter_index)} />
                                                                                </Col>
                                                                                <Col xs={24} sm={12}>
                                                                                    <InputItem placeholder="Enter Value" value={parameter.value} onChange={(e) => onChangeResetParameterValue(e.target.value, index, parameter_index)} />
                                                                                </Col>
                                                                                <div className="ori-absolute ori-align-top-10 ori-align-left-full ori-align-top-quarter">
                                                                                    <Popconfirm overlayClassName="ori-zindex-99999" placement="topRight" title="Are you sure?" okText="Yes" cancelText="No" onConfirm={() => { deleteResetParameter(index, parameter_index); }}>
                                                                                        <div className="ori-pad-3">
                                                                                            <IconDelete size={18} className="ori-font-light-hover-primary ori-cursor-ptr" />
                                                                                        </div>
                                                                                    </Popconfirm>
                                                                                </div>
                                                                            </Row>
                                                                        </ErrorBoundary>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                        <Button type="dashed" className="ori-full-width ori-tb-mrgn-5" onClick={() => { addResetParameter({ key: undefined, value: "" }, index, edge.resetParameters ? edge.resetParameters.length : 0) }}>Add Reset Parameter</Button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </ErrorBoundary>
                                );
                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

EntityNodeForm.propTypes = {
    show_edit_edges: PropTypes.bool,
    getPreemptiveData: PropTypes.func,
    preemptive_data: PropTypes.object,
    workflows: PropTypes.array,
    possible_rules: PropTypes.array,
    node_details: PropTypes.object,
    onChangeName: PropTypes.func,
    onChangeAction: PropTypes.func,
    onChangeVariable: PropTypes.func,
    onChangeEventTagType: PropTypes.func,
    onChangeEventTag: PropTypes.func,
    onChangeStart: PropTypes.func,
    onChangeEnd: PropTypes.func,
    onChangeAuthRequired: PropTypes.func,
    addMessageBefore: PropTypes.func,
    onClickDeleteMessageBefore: PropTypes.func,
    addMessageAfter: PropTypes.func,
    onClickDeleteMessageAfter: PropTypes.func,
    onChangeTargetWorkflow: PropTypes.func,
    onChangeTargetNode: PropTypes.func,
    onChangeLabel: PropTypes.func,
    onChangeCustomRule: PropTypes.func,
    onChangeRule: PropTypes.func,
    onChangeResetParameterKey: PropTypes.func,
    onChangeResetParameterValue: PropTypes.func,
    deleteResetParameter: PropTypes.func,
    addResetParameter: PropTypes.func,
};

EntityNodeForm.defaultProps = {
    show_edit_edges: false,
    onChangeEventTagType: ()=>{},
    onChangeEventTag: () => {}
};

export default EntityNodeForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/workflows/workflowdiagram/entitynodeform/index.js